import React from "react";
import { Modal } from "@mui/material";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";

import Icon from "../../assets/mark-no-show.svg";
import "./component-styles.scss";
import swal from "sweetalert";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
export default function MarkNoShowModal(props) {
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  // TODO: show error message if post call fails.
  function markNoShow() {
    let payload = {
      appointment_id: props.appointment_id,
      doctor_id: props.doctor_id,
      staff_id: staffId,
    };

    afterLoginApiAxios
      .post("/doctor/mark-no-show", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((response) => {
        C2CConsole.log(response);
        if (response.data) {
          if (response.data.statusCode === 200) {
            props.refreshAppointmentsMethod();
            props.callNextAppointmentWidget &&
              props.callNextAppointmentWidget();
            props.closeView();
            swal({
              type: "success",
              title: "Success",
              icon: "success",
              text: response.data.message,
            });
          } else {
            // TODO: Error handling and logging
            swal({
              type: "error",
              title: "Error",
              icon: "error",
              text: response.data.message,
            });
          }
        } else {
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  return (
    <>
      {props.openView ? (
        <Modal open={props.openView} onClose={props.closeView}>
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="mark-no-show-modal-wrapper p-3 p-lg-5">
              <div className="d-flex flex-column justify-content-center align-items-center modal_action_heading">
                <img src={Icon} alt="success" />
                <h4 className="mt-3">Mark No Show</h4>
                <p className="text-center my-2">
                  This appointment will be removed from your calendar and will
                  appear as no-show in your appointment history.
                </p>
                <div className="d-flex flex-row justify-content-center my-3 modal_action_button">
                  <button
                    className="btn primary-cta-button rounded-pill px-5 first_button"
                    onClick={markNoShow}
                  >
                    Confirm
                  </button>
                  <button
                    className="btn secondary-button rounded-pill px-5 secon_button"
                    onClick={props.closeView}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
}
